/**
 * Corso — a training unit in the built-in LMS.
 * Source: Marko spec §8. coreBOS-A: existing LMS engine; only content is configured.
 *
 * `obbligatorio_art4` marks courses that fulfil the AI Act Art. 4 (alfabetizzazione AI)
 * obligation. The Attestato child record is the Art. 4 per-person evidence an auditor asks for.
 * States: Bozza → Pubblicato → Archiviato.
 */
export const courseDescriptor = {
    slug: 'course',
    kind: 'document',
    label: { singular: 'Corso', plural: 'Corsi' },
    table: 'ai_portal_course',
    idStrategy: 'sha256',
    fields: [
        { name: 'titolo_corso', type: 'text', label: 'Titolo corso', required: true },
        { name: 'descrizione', type: 'text', label: 'Descrizione', required: true },
        { name: 'contenuto', type: 'text', label: 'Contenuto (HTML)', required: true },
        { name: 'ruolo_area_destinataria', type: 'text', label: 'Ruolo o area destinataria', required: true },
        { name: 'durata_stimata_min', type: 'number', label: 'Durata stimata (min)' },
        { name: 'obbligatorio_art4', type: 'boolean', label: 'Obbligatorio Art. 4', required: true },
        { name: 'stato', type: 'text', label: 'Stato', required: true },
        // Bozza | Pubblicato | Archiviato
    ],
    behaviors: {
        ownership: true,
        audit: true,
        tenantScoped: true,
    },
    emits: ['course.published', 'course.archived'],
    ui: { mode: 'generated', icon: 'ReadOutlined', navGroup: 'Formazione', navOrder: 30 },
};
